module.exports = __webpack_public_path__ + "media/images/pin_on-1cb319fe01c33bb72559776df8d31c80.svg";